/* src/app/modules/product-labels/inline-labels-picker/inline-labels-picker.component.scss */
.inline-picker-container {
  display: flex;
  align-items: center;
  width: fit-content;
}
.disabled {
  cursor: not-allowed;
  opacity: 50%;
}
.label-picker {
  display: block;
  width: 35rem;
  height: 18.5rem;
  overflow-y: scroll;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-thumb {
  background: #9fa2ad;
  border-left: 4px white solid;
  background-clip: padding-box;
}
/*# sourceMappingURL=inline-labels-picker.component.css.map */
